import React from 'react';
import ReactDOM from 'react-dom/client';

// =====================================================================
// CSS canonical do Design System Bloco D — ordem determinística.
// IMPORTANTE: tokens.css define :root variables, system.css usa elas,
// components.css define os "componentes especiais" (Fase 1: .eh,
// .kpi-strip-v2, .block, .so-panel, .fp, .pm, .timeline-audit) e
// responsive-additions.css aplica @media queries em cima.
// tokens.css + system.css + components.css são byte-a-byte idênticos
// aos originais em design-handoff/extracted/. Verificável via
// `npm run audit:canonical`.
// =====================================================================
import './styles/canonical/tokens.css';
import './styles/canonical/system.css';
import './styles/canonical/components.css';
// Camada Fase-3 (Comercial): kanban CRM, health-ring, crm-timeline.
// Byte-identica a design-handoff/extracted/fase-3---modulo-comercial.
import './styles/canonical/comercial.css';
// REF-16 — classes da pagina Minhas Pendencias (extraido do mockup aprovado).
import './styles/canonical/minhas-pendencias.css';
import './styles/canonical/chat.css';
// Hub de Configuracoes unificado (extraido do mockup aprovado).
import './styles/canonical/configuracoes.css';
// Orcamento v2 — pagina do orcamento + slide-overs (extraido do mockup
// "Orcamento"; tudo escopado sob .orc2/.orc2-panel).
import './styles/canonical/orcamento-v2.css';
// Financeiro v2 — modulo Financeiro + Fiscal + Cobranca (extraido do mockup
// "Fase 5 V2.2"; tudo escopado sob .fin2/.fin2-panel).
import './styles/canonical/financeiro-v2.css';
// Cliente 360 — pagina de Detalhe do Cliente (extraido do mockup aprovado;
// tudo escopado sob .cli360, tokens aliasados aos canonicos).
import './styles/canonical/cliente360.css';
import './styles/canonical/responsive-additions.css';

// Resets/utilidades locais mínimos — system.css já cobre body+reset.
import './index.css';

import App from './App';

import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Rebrand 2026-08: as chaves persistidas trocaram de prefixo (dash-pcp:* ->
// pharuerp:*). Sem esta migracao, todo usuario perderia sessao, tema, filtros
// e rascunhos no primeiro acesso pos-deploy. Roda antes do render (o iframe
// oculto do agendador usa o mesmo bundle, entao migra tambem). Idempotente:
// nunca sobrescreve chave nova ja gravada.
function migrarPrefixosLegados() {
  try {
    const legados = ['dash-pcp:', 'dasherp:', 'dash-erp:'];
    const chaves = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      chaves.push(window.localStorage.key(i));
    }
    chaves.forEach((chave) => {
      const prefixo = legados.find((p) => chave && chave.startsWith(p));
      if (!prefixo) return;
      const nova = 'pharuerp:' + chave.slice(prefixo.length);
      if (window.localStorage.getItem(nova) === null) {
        window.localStorage.setItem(nova, window.localStorage.getItem(chave));
      }
      window.localStorage.removeItem(chave);
    });
  } catch (_) {
    // localStorage indisponivel (modo privado) — segue sem migrar.
  }
}
migrarPrefixosLegados();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registra o service worker para instalação PWA e cache offline.
// Só atua em produção ou quando REACT_APP_FORCE_SW=1 (build local servido
// estaticamente). Em `npm start` (dev) fica desligado para não cachear
// hot-reload incorretamente.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
